import ui from '../../ui';
import localStorage from '@/utils/localStorage';
import env from '@/utils/env';
import _ from '@/utils/datetime';
import offlineService from '@/api/offline';
import queryString from '@/utils/query-string.js';

// XXX
// 如果没找到组件就交给服务器处理
// 比如：页面A import B，之后从B去到第三方页面，返回，此时由于B可以独立访问
// 所以没问题，但是再返回时，因为B没有import A所以没有匹配到组件。
export function reloadIfNotFound(to, from, next) {
  if (to.matched && to.matched.length > 0) {
    next();
  } else {
    window.location.reload();
  }
}

export function hideAllModal(to, from, next) {
  ui.hidePicker();
  ui.hideLoading();
  ui.hidePopup();
  ui.hideNotification();
  ui.hideOptions();

  next();
}


export function setAuthAndPtid(to, from, next) {
  setAuth(to);
  setPtid(to);

  next();
}

function setAuth(route) {
  if (route.query) {
    if (route.query.authcode) {
      localStorage.set('authcode', decodeURIComponent(route.query.authcode))
      localStorage.remove('authExpiretime')
      localStorage.remove('refreshcode')
      localStorage.remove('refreshExpiretime')
    }

    if (route.query.refreshcode) {
      localStorage.set( 'refreshcode', decodeURIComponent(route.query.refreshcode) );
      localStorage.remove('refreshExpiretime')
    }

    if (route.query.refreshExpiretime) {
      localStorage.set('refreshExpiretime', _.format("%Y-%m-%d %T", Number(route.query.refreshExpiretime)));
    }

    if (route.query.sessionid) {
      let wxdepartment = localStorage.get('wxdepartment');
      if (wxdepartment === 'hbgj' && route.query.openid) { //航班网页授权只保存返回值openid用于微信支付
        localStorage.set('hbOpenid', decodeURIComponent(route.query.openid));
      } else {
        localStorage.set('wxsessionid', decodeURIComponent(route.query.sessionid));
      }
      localStorage.remove('wxdepartment');
    }
  }
}

function setPtid(route) {
  if (route.query) {
    if (route.query.ptid) {
      let ptid = decodeURIComponent(route.query.ptid);
      document.documentElement.className = ptid;
      localStorage.set('ptid', ptid);
    }
    if (route.query.subptid) {
      let subptid = decodeURIComponent(route.query.subptid);
      localStorage.set('subptid', subptid);
    }
  }
}

export function updateTitle(to) {
  setTimeout(() => {
    const title = to.meta && to.meta.title;

    // 如果不需要标题就传空字符串('')，会被替换成\u200e
    if (title) {
      ui.updateTitle(title);
    } else if (title === '') {
      ui.updateTitle('\u200e');
    }
  });
}

export function setNavColor(to) {
  setTimeout(() => {
    const tintColor = to.meta && to.meta.tintColor || '';
    const tintColorStyle = to.meta && to.meta.tintColorStyle || '1';
    const statusBarStyle = to.meta && to.meta.statusBarStyle || '1';

    if (tintColor) {
      ui.setNavColor(tintColor, tintColorStyle, statusBarStyle);
    }
  });
}

export function routechange() {
  setTimeout(() => {
    let url = window.location.href || '';
    url = url.replace(/(userid=|agent=)(.*)platform=([^&]*)(&+|$)/, '')
    if (url.indexOf("ptid=") === -1) {
      let ptid = localStorage.get('ptid') || (env.isWeixin ? 'wechat' : '') || (env.isQuickApp || env.quickappBrand ? 'quickapp' : '');
      let subptid = localStorage.get('subptid') || env.quickappBrand || ''
      if (url.indexOf("?") === -1) {
        url += `?ptid=${ptid}${subptid ? '&subptid=' + subptid : ''}`;
      } else {
        url += `&ptid=${ptid}${subptid ? '&subptid=' + subptid : ''}`;
      }
    }

    const path          = url.split( '?' )[ 0 ];
    const originalQuery = queryString.parse( url );
    const trackKeyList  = [ 'ptid', 'subptid' ];
    const query         = {};

    for ( let item of trackKeyList ) {
      if ( originalQuery[ item ] ) {
        query[ item ] = originalQuery[ item ];
      }
    }

    const trackQueryString = queryString.build( query );

    if ( trackQueryString ) {
      url = path + '?' + trackQueryString;
    }

    if (window.ha) {
      ha('send', 'pageview', url);
    }

    document.dispatchEvent(new Event('routechange'));
  });
}

export function checkOffline(to, from, next) {
  //活动下线检查
  if (to && to.meta && to.meta.offline) {
    offlineService.checkOffline({
      actId: to.meta.offline
    }).then((result) => {
      //已下线
      if (result) {
        if (window && window.location && window.location.replace) {
          /* global OFFLINE_URL */
          window.location.replace(OFFLINE_URL);
        } else {
          /* global OFFLINE_URL */
          window.location.href = OFFLINE_URL;
        }
      } else {
        next()
      }
    })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/app/router/hooks.js